import {AssetPropertyDto} from '../../../common/shared/api/nicolas/vo/AssetPropertyDto.interface';
import {isNilEmpty} from '../../../common/shared/utils/isNilEmpty';

export const getCardThumbnail = (
  thumbnail: string,
  asset_property?: AssetPropertyDto,
  isBook?: boolean
) => {
  // 단행본 or 책
  if (isBook) {
    return thumbnail;
  }

  const {card_set, card_img, card_cover} = asset_property ?? {};

  // 1순위 (new card set)
  if (!isNilEmpty(card_set) && !isNilEmpty(card_set.background_img)) {
    return card_set.background_img as string;
  }

  // 2순위 (old card set)
  if (!isNilEmpty(card_img)) {
    return card_img as string;
  }

  // 3순위 (작품 표지)
  if (!isNilEmpty(card_cover) && !isNilEmpty(card_cover.cover_img)) {
    // 기획서에는 "작품 표지 가공" 이고 API는 "작품 표지 제한(cover_restricted)" 의미라서 헷갈릴 수 있다
    // - 작품 표지 가공 허용 O = 작품 표지를 좌우 크롭해서 사용
    // - 작품 표지 가공 허용 X = 작품 표지를 카드뷰(책) 형태로 제공
    return card_cover.cover_img as string;
  }

  // 4순위
  return thumbnail as string;
};
